import { Routes, Route, Link, useLocation } from 'react-router-dom';
import Dashboard from './pages/Dashboard';
import StoriesPage from './pages/StoriesPage';
import StoryDetailPage from './pages/StoryDetailPage';
import MatchDetailPage from './pages/MatchDetailPage';
import ConfigPlayground from './pages/ConfigPlayground';

function NavLink({ to, children }: { to: string; children: React.ReactNode }) {
  const location = useLocation();
  const isActive = location.pathname === to ||
    (to !== '/' && location.pathname.startsWith(to));

  return (
    <Link
      to={to}
      className={`px-3 py-2 rounded-md text-sm font-medium transition-colors ${
        isActive
          ? 'bg-pebbl-700 text-white'
          : 'text-pebbl-100 hover:bg-pebbl-500'
      }`}
    >
      {children}
    </Link>
  );
}

export default function App() {
  return (
    <div className="min-h-screen">
      {/* Navigation */}
      <nav className="bg-pebbl-600 shadow-lg">
        <div className="max-w-7xl mx-auto px-4">
          <div className="flex items-center justify-between h-16">
            <div className="flex items-center">
              <Link to="/" className="text-white font-bold text-xl">
                Pebbl Admin
              </Link>
              <div className="ml-10 flex items-center space-x-2">
                <NavLink to="/">Dashboard</NavLink>
                <NavLink to="/stories">Stories</NavLink>
                <NavLink to="/playground">Playground</NavLink>
              </div>
            </div>
            <div className="text-pebbl-200 text-sm">
              v2.0 - Debug UI
            </div>
          </div>
        </div>
      </nav>

      {/* Main Content */}
      <main className="max-w-7xl mx-auto px-4 py-6">
        <Routes>
          <Route path="/" element={<Dashboard />} />
          <Route path="/stories" element={<StoriesPage />} />
          <Route path="/stories/:id" element={<StoryDetailPage />} />
          <Route path="/matches/:id" element={<MatchDetailPage />} />
          <Route path="/playground" element={<ConfigPlayground />} />
        </Routes>
      </main>
    </div>
  );
}
